import { v4 as createUUID } from 'uuid';
import coinflip from '../../coinflip';
import { getDoNotAbortActivePressInteraction, getInteractionRate, getMinorInteractions } from '../../config';
import { getActiveTrace, setInteractionActiveTrace } from '../../experience-trace-id-context';
import { DefaultInteractionID } from '../../interaction-id-context';
import { abortAll, addNewInteraction, getActiveInteraction } from '../../interaction-metrics';
import UFORouteName from '../../route-name-context';
function traceUFOInteraction(name, interactionType, startTime) {
  var _getMinorInteractions;
  var rate = getInteractionRate(name, interactionType);
  var pressInteractionsList = getDoNotAbortActivePressInteraction();
  var minorInteractions = (pressInteractionsList !== null && pressInteractionsList !== void 0 ? pressInteractionsList : []).concat((_getMinorInteractions = getMinorInteractions()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []);
  if (minorInteractions.includes(name)) {
    var _activeInteraction$mi;
    var activeInteraction = getActiveInteraction();
    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
      name: name,
      startTime: startTime !== null && startTime !== void 0 ? startTime : performance.now()
    });
    return;
  } else {
    abortAll('new_interaction', name);
  }
  if (coinflip(rate)) {
    var startTimestamp = startTime !== null && startTime !== void 0 ? startTime : performance.now();
    var newId = createUUID();
    DefaultInteractionID.current = newId;

    // covered experiences with tracing instrumentation:
    // inline-result.inline-card-create-submit
    setInteractionActiveTrace(newId, interactionType);
    addNewInteraction(newId, name, interactionType === 'hover' ? 'press' : interactionType,
    // TODO add dedicated type for hover, might change backend though
    startTimestamp, rate, [], UFORouteName.current, getActiveTrace());
  }
}
export default traceUFOInteraction;